import { useState } from 'react';
import { toast } from 'react-toastify';

import { TotemInput } from 'components/TotemInput';
import { TotemPrimaryButton } from 'components/TotemPrimaryButton';

import { useChangePasswordMutation } from 'data/__generated__';
import { setTokens } from 'data/connection/storage';

import styled from 'styled-components';

export const PasswordSettings = (): JSX.Element => {
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [passwordError, setPasswordError] = useState<string | null>(null);
    const [changePasswordMutation, { loading: changePasswordLoading }] = useChangePasswordMutation();

    const handleChangePassword = async (): Promise<void> => {
        setPasswordError(null);
        if (newPassword.length < 6) {
            setPasswordError('Le mot de passe doit contenir au moins 6 caractères');
            return;
        }
        if (newPassword !== confirmPassword) {
            setPasswordError('Les mots de passe ne correspondent pas');
            return;
        }
        const { data } = await changePasswordMutation({ variables: { password: newPassword } });
        if (data?.changePassword?.success) {
            // Le serveur a fermé toutes les sessions, celle-ci comprise : elle continue sur la paire neuve.
            const { token, refreshToken } = data.changePassword;
            if (token && refreshToken) {
                setTokens(token, refreshToken);
            }
            toast.success('Mot de passe mis à jour');
            setNewPassword('');
            setConfirmPassword('');
        } else {
            setPasswordError(data?.changePassword?.error || 'Une erreur est survenue');
        }
    };

    return (
        <>
            <SectionTitle>Mot de passe</SectionTitle>
            <TotemInput
                value={newPassword}
                placeholder="Nouveau mot de passe"
                type="password"
                onChange={(value) => setNewPassword(value)}
            />
            <TotemInput
                value={confirmPassword}
                placeholder="Confirmer le mot de passe"
                type="password"
                onChange={(value) => setConfirmPassword(value)}
            />
            {passwordError ? <ErrorMessage>{passwordError}</ErrorMessage> : null}
            <TotemPrimaryButton
                onClick={handleChangePassword}
                disabled={changePasswordLoading || newPassword.length === 0 || confirmPassword.length === 0}
            >
                {changePasswordLoading ? 'Mise à jour...' : 'Mettre à jour le mot de passe'}
            </TotemPrimaryButton>
        </>
    );
};

const SectionTitle = styled.h3`
    color: ${({ theme }) => theme.textColor};
    margin-top: 20px;
    margin-bottom: 5px;
    font-size: 16px;
`;

const ErrorMessage = styled.span`
    color: ${({ theme }) => theme.errorColor};
    font-size: 13px;
`;
